// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Pervasives from "../../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Icon$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/icons/Icon.bs.js";
import * as PartnerStatus from "../../../../app/partner/entity/PartnerStatus.bs.js";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as FilterPartnerForm from "./FilterPartnerForm.bs.js";
import * as PartnerEngagement from "../../../../app/filter-partners/entity/PartnerEngagement.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FilterPartnerRequest from "../../../../app/filter-partners/entity/FilterPartnerRequest.bs.js";
import * as GeoRegionRepoManager from "../../../../../../../library/data-source/geo-region/repo/GeoRegionRepoManager.bs.js";
import * as SeeMoreButton$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/SeeMoreButton.bs.js";
import * as OptionTypeUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/OptionTypeUtils.bs.js";
import * as RoundedPrimaryButton$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/RoundedPrimaryButton.bs.js";

function reloadTab(filter, workspaceDispatch) {
  return Curry._1(workspaceDispatch.replaceTab, {
              TAG: /* FilterPartner */41,
              _0: FilterPartnerRequest.toDict(filter)
            });
}

function setInitState(params) {
  return {
          filter: FilterPartnerRequest.fromDict(params),
          data: {
            TAG: /* Loading */0,
            _0: undefined
          }
        };
}

function fetchDriver(filter, offset, geo_region_id, dispatch, loadedData, country) {
  var RepoInstance = CrmRepoManager.getDriverRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.fetchFilterDrivers, {
                            geo_region_id: geo_region_id,
                            vehicle_id: filter.vehicle_id,
                            engagement_type: filter.engagement_type,
                            status: filter.status,
                            availability: filter.availability,
                            gps_location: filter.gps_location,
                            active_status: filter.active_status,
                            login_status: filter.login_status,
                            msisdn: filter.msisdn,
                            driver_name: filter.driver_name,
                            cluster_name: filter.cluster_name,
                            vehicle_number: filter.vehicle_number
                          }, offset, country);
              }), (function (res) {
                return Curry._1(dispatch, {
                            TAG: /* SetData */0,
                            data: {
                              TAG: /* Live */1,
                              _0: Pervasives.$at(Belt_Option.getWithDefault(loadedData, /* [] */0), res.drivers)
                            },
                            offset: res.offset.value,
                            end_of_list: List.length(res.drivers) === 0,
                            total_items: res.total_count
                          });
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetData */0,
                            data: {
                              TAG: /* Error */2,
                              _0: error
                            },
                            offset: undefined,
                            end_of_list: false,
                            total_items: 0
                          });
              }));
}

function loadData(filter, offset, dispatch, loadedData, country) {
  var drivers = offset !== undefined ? loadedData : undefined;
  Curry._1(dispatch, {
        TAG: /* BeforeDataFetch */1,
        data: {
          TAG: /* Loading */0,
          _0: drivers
        },
        filter_request: filter
      });
  var match = filter.geo_region_id;
  if (match !== undefined) {
    return fetchDriver(filter, offset, filter.geo_region_id, dispatch, drivers, country);
  }
  var GeoRegionRepo = GeoRegionRepoManager.getRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._1(GeoRegionRepo.fetchGeoRegions, country);
              }), (function (res) {
                return fetchDriver(filter, offset, List.nth(res, 0).id, dispatch, drivers, country);
              }), (function (error) {
                return Curry._1(dispatch, {
                            TAG: /* SetData */0,
                            data: {
                              TAG: /* Error */2,
                              _0: error
                            },
                            offset: undefined,
                            end_of_list: false,
                            total_items: 0
                          });
              }));
}

function tableConfig(workspaceDispatch, visibleKey, showData, pageAccessType) {
  return {
          hd: {
            column: {
              TAG: /* Text */0,
              _0: "Visiblity"
            },
            accessor: (function (data) {
                return {
                        TAG: /* Custom */5,
                        _0: (function (param) {
                            if (visibleKey !== undefined) {
                              if (visibleKey === data.msisdn) {
                                return React.createElement("div", {
                                            className: "visibility-on-icon",
                                            onClick: (function (param) {
                                                return Curry._1(showData, undefined);
                                              })
                                          }, React.createElement(Icon$Catalyst.VisibilityIcon.make, {
                                                fontSize: "Large"
                                              }));
                              } else {
                                return React.createElement("div", {
                                            className: "visibility-off-icon",
                                            onClick: (function (param) {
                                                return Curry._1(showData, data.msisdn);
                                              })
                                          }, React.createElement(Icon$Catalyst.VisibilityOffIcon.make, {
                                                fontSize: "Large"
                                              }));
                              }
                            } else {
                              return React.createElement("div", {
                                          className: "visibility-off-icon",
                                          onClick: (function (param) {
                                              return Curry._1(showData, data.msisdn);
                                            })
                                        }, React.createElement(Icon$Catalyst.VisibilityOffIcon.make, {
                                              fontSize: "Large"
                                            }));
                            }
                          })
                      };
              })
          },
          tl: {
            hd: {
              column: {
                TAG: /* Text */0,
                _0: "Geo Region"
              },
              accessor: (function (data) {
                  return {
                          TAG: /* Text */0,
                          _0: data.city
                        };
                })
            },
            tl: {
              hd: {
                column: {
                  TAG: /* Text */0,
                  _0: "MSISDN"
                },
                accessor: (function (data) {
                    if (visibleKey !== undefined && visibleKey === data.msisdn) {
                      return {
                              TAG: /* Text */0,
                              _0: data.msisdn
                            };
                    } else {
                      return {
                              TAG: /* Text */0,
                              _0: "*************"
                            };
                    }
                  })
              },
              tl: {
                hd: {
                  column: {
                    TAG: /* Text */0,
                    _0: "Name"
                  },
                  accessor: (function (data) {
                      return {
                              TAG: /* Custom */5,
                              _0: (function (param) {
                                  return React.createElement(RoundedPrimaryButton$Catalyst.make, {
                                              buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                                    TAG: /* Text */0,
                                                    _0: data.name
                                                  }, undefined, (function (param) {
                                                      return Curry._2(workspaceDispatch.addTab, {
                                                                  TAG: /* DriverDashboardV2 */5,
                                                                  _0: data.msisdn
                                                                }, false);
                                                    }), undefined, Caml_option.some(React.createElement(Icon$Catalyst.NavigateIcon.make, {
                                                            fontSize: "Default"
                                                          })), undefined, undefined, undefined, undefined, undefined)
                                            });
                                })
                            };
                    })
                },
                tl: {
                  hd: {
                    column: {
                      TAG: /* Text */0,
                      _0: "Secondary Mobile"
                    },
                    accessor: (function (data) {
                        if (visibleKey !== undefined && visibleKey === data.msisdn) {
                          return {
                                  TAG: /* Text */0,
                                  _0: data.secondary_mobile
                                };
                        } else {
                          return {
                                  TAG: /* Text */0,
                                  _0: "*************"
                                };
                        }
                      })
                  },
                  tl: {
                    hd: {
                      column: {
                        TAG: /* Text */0,
                        _0: "Status"
                      },
                      accessor: (function (data) {
                          return {
                                  TAG: /* Text */0,
                                  _0: PartnerStatus.toString(data.status)
                                };
                        })
                    },
                    tl: {
                      hd: {
                        column: {
                          TAG: /* Text */0,
                          _0: "Available"
                        },
                        accessor: (function (data) {
                            return {
                                    TAG: /* Text */0,
                                    _0: Pervasives.string_of_bool(data.is_available)
                                  };
                          })
                      },
                      tl: {
                        hd: {
                          column: {
                            TAG: /* Text */0,
                            _0: "Vehicle"
                          },
                          accessor: (function (data) {
                              return {
                                      TAG: /* Text */0,
                                      _0: data.vehicle_type
                                    };
                            })
                        },
                        tl: {
                          hd: {
                            column: {
                              TAG: /* Text */0,
                              _0: "Engagement"
                            },
                            accessor: (function (data) {
                                return {
                                        TAG: /* Text */0,
                                        _0: PartnerEngagement.to_string(data.engagement_type)
                                      };
                              })
                          },
                          tl: {
                            hd: {
                              column: {
                                TAG: /* Text */0,
                                _0: "App Version"
                              },
                              accessor: (function (data) {
                                  return {
                                          TAG: /* Text */0,
                                          _0: Belt_Option.mapWithDefault(data.app_version.value, "N/A", (function (prim) {
                                                  return String(prim);
                                                }))
                                        };
                                })
                            },
                            tl: {
                              hd: {
                                column: {
                                  TAG: /* Text */0,
                                  _0: "Vehicle Stand"
                                },
                                accessor: (function (data) {
                                    return {
                                            TAG: /* Custom */5,
                                            _0: (function (param) {
                                                return React.createElement(SeeMoreButton$Catalyst.make, {
                                                            msg: Belt_Option.getWithDefault(data.vehicle_stand.value, "N/A"),
                                                            length: 40
                                                          });
                                              })
                                          };
                                  })
                              },
                              tl: {
                                hd: {
                                  column: {
                                    TAG: /* Text */0,
                                    _0: "Last Updated At"
                                  },
                                  accessor: (function (data) {
                                      return {
                                              TAG: /* Text */0,
                                              _0: OptionTypeUtils$Catalyst.getDateStringFromOptionType(data.last_updated_at.value)
                                            };
                                    })
                                },
                                tl: /* [] */0
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function FilterPartnerConfig$T$FilterForm(Props) {
  var filter = Props.filter;
  var applyFilter = Props.applyFilter;
  var total_items = Props.total_items;
  return React.createElement(FilterPartnerForm.make, {
              filter: filter,
              applyFilter: applyFilter,
              total_items: total_items
            });
}

var FilterForm = {
  make: FilterPartnerConfig$T$FilterForm
};

var T = {
  setInitState: setInitState,
  pageTitle: "Filtered Partners",
  loadData: loadData,
  reloadTab: reloadTab,
  tableConfig: tableConfig,
  FilterForm: FilterForm
};

export {
  T ,
  
}
/* react Not a pure module */
